export const DATE_TIME_DAYJS_FORMAT = "MMMM DD, YYYY, h:mm A";

export const DATE_DAYJS_FORMAT = "MMMM DD, YYYY";

export enum ENVTYPE {
  PRODUCTION = "production",
  DEVELOPMENT = "development",
  STAGING = "staging",
}

export const STYTCH_MEMBER = "stytch_member";

export const fileErrorTypes = new Set(["too_many_files", "too_large", "duplicate_files", "failed"])

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;